// extracted by mini-css-extract-plugin
export default {"editIamge":"style_editIamge__2GlIv","changePasswordModal":"style_changePasswordModal__6pa2y","formGroup":"style_formGroup__lTqpn","PrfileIamge":"style_PrfileIamge__YHJJ3"};